import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/globals.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/client/node_modules/@mantine/core/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/components/PWAInstallPrompt.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/client/src/layout/DefaultLayout.tsx");
